const search = ({
  eventName,
  query,
  plan,
  country,
  city,
  zipCode,
  type,
  category,
  time,
  location,
  totalCount,
}) => ({
  event: `${eventName}`,
  search: {
    type,
    activities: category && category,
    venues: location && location,
    time,
    term: query || '',
    plan: plan || '',
    city: city || '',
    zip: zipCode && zipCode,
    venue: {
      country: country && country,
    },
    results: totalCount || 0,
  },
});

export default search;



// WEBPACK FOOTER //
// ./resources/assets/js/components/eventTracker/dataLayer/search.js